import React from 'react';
import Editor from 'react-simple-code-editor';
import { highlightJexlToHtml } from '../utils/jexlHighlight';

import './JexlCodeEditor.css';

type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** If true, only values in {# ... } are highlighted; otherwise whole string is Jexl (e.g. row filter). */
  defaultValueStyle?: boolean;
  /** Multi-line (textarea-like) for row filter. */
  multiline?: boolean;
  className?: string;
  disabled?: boolean;
};

/**
 * Inline syntax-highlighted code editor for Jexl expressions.
 * Highlighting is shown directly in the field (e.g. after focus leave).
 */
export const JexlCodeEditor: React.FC<Props> = ({
  value,
  onChange,
  placeholder = '',
  defaultValueStyle = false,
  multiline = false,
  className = '',
  disabled = false
}) => {
  const highlight = (code: string) => highlightJexlToHtml(code, defaultValueStyle);

  return (
    <div className={`jexl-code-editor-wrapper ${className}`}>
      <Editor
        value={value ?? ''}
        onValueChange={onChange}
        highlight={highlight}
        placeholder={placeholder}
        disabled={disabled}
        padding={8}
        style={{
          minHeight: multiline ? 56 : 36,
          fontSize: 14,
          fontFamily: 'ui-monospace, monospace'
        }}
        textareaClassName="jexl-code-editor-textarea"
        preClassName="jexl-code-editor-pre"
        tabSize={2}
        insertSpaces
      />
    </div>
  );
};

export default JexlCodeEditor;
